/**
 * The Manager+ tier for the pipeline surface (epic decision P3).
 *
 * Extracted to a leaf module so both the gate itself
 * (`hooks/useIsPipelineManager`) and its telemetry counterpart
 * (`hooks/usePipelineTierBlock`, SE-5508) can read the SAME role set without
 * either importing the other. That matters twice over:
 *
 * - Correctness: the event that reports a denial must be driven by the exact
 *   set that causes the denial. Two copies could drift, and a drift here would
 *   emit `tier_block_render` for a user who was in fact granted access —
 *   silently corrupting the epic's zero-leak metric.
 * - Module weight: `useIsPipelineManager` imports the `@/features/auth`
 *   barrel, which re-exports auth screens and pulls `expo-device` in behind
 *   them. Importing the role set from there would drag that whole graph into
 *   `useNavItems` and every consumer of it.
 * @module features/player-kanban/constants/pipelineTierRoles
 */

/**
 * Organization roles that clear the Manager+ pipeline gate.
 *
 * Everything not in this set — notably `RoleName.Member`, the "Scout tier"
 * (Tier 3) of the PRD — is denied the pipeline surface.
 *
 * SE-6936 promoted the set itself to `@/constants/managerPlusRoles` so that
 * Squad's new gate and this one cannot answer "who is a Manager" differently.
 * This module stays as the pipeline's named entry point — the leaf-module
 * property described above is preserved, since the shared module imports
 * nothing but the generated enum.
 */
export { MANAGER_PLUS_ROLES } from "@/constants/managerPlusRoles";
